
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdJaF683ROKfKyXXMiyqDaR1KwZGA8sf02gv4JsirbG8Meta } from "/codebuild/output/src2732330269/src/repo/pages/index.vue?macro=true";
import { default as loginC39ONcVRpLatST00n23ETySFJ6usaUOuxGmO4gGZmj8Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/login.vue?macro=true";
import { default as verifyCC7JR1iPNmdNChcOn8_45R0Gu215iBAKbtVJk9MA4SfyQMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/verify.vue?macro=true";
import { default as supportFjdsqARRTg64JTQqzDZOE2f2aHH5id0xxZBDT7xOteQMeta } from "/codebuild/output/src2732330269/src/repo/pages/support.vue?macro=true";
import { default as registerceMIts4N6rWFNFHnzy3ZOmPmKEJfJJ4oT9N31BoU7fkMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/register.vue?macro=true";
import { default as onboardingheK_45ra6n21nAAiqHHVo1SNVcu_HdzN1c_3OAnTUp09EMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/onboarding.vue?macro=true";
import { default as indexSA48ABsVnvnWWcJq3UEAGf3aZSe7VuOHozRMmw_52XYMeta } from "/codebuild/output/src2732330269/src/repo/pages/carts/index.vue?macro=true";
import { default as marketplaceE1aGFU9ed8D3E3gKX3J5Cnij17HjJfTCDDPHd9S1RiAMeta } from "/codebuild/output/src2732330269/src/repo/pages/marketplace.vue?macro=true";
import { default as index05mETgeaOYCyhLRBaVPsJJKNxGIuVjQ2hgTHss_autcMeta } from "/codebuild/output/src2732330269/src/repo/pages/orders/[id]/index.vue?macro=true";
import { default as mark_45as_45delivered5wzjR2bntzpeQhmSUXTklvLuseX_clAqSs1ogu3d6CcMeta } from "/codebuild/output/src2732330269/src/repo/pages/orders/[id]/mark-as-delivered.vue?macro=true";
import { default as _91id_93LFYE_bBPTeWH49uzkDJTxm0oZQOu6ntZEHV8_jgSmO8Meta } from "/codebuild/output/src2732330269/src/repo/pages/orders/[id].vue?macro=true";
import { default as index8cUZfaAEA3n_45OP1DiKw6U8f0SPvI_b6dBtavE48WfpsMeta } from "/codebuild/output/src2732330269/src/repo/pages/tools/index.vue?macro=true";
import { default as indexsGvGKn4vWBlvLM7ar6Lvqygol9yTiFhl_BAWnCX1TfMMeta } from "/codebuild/output/src2732330269/src/repo/pages/browse/index.vue?macro=true";
import { default as indexcc8QD2hncOQXVM0OLwiQx5D7JHidhBjd1_45Pw6BmbSxcMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/index.vue?macro=true";
import { default as aboutljk_vfsivC5K9uoQqaficHZuUdaaehj1XDy6cJPX5eAMeta } from "/codebuild/output/src2732330269/src/repo/pages/account/about.vue?macro=true";
import { default as indexQ9kssc_45OkdHBDuRVJwDjTni81KZ5oISNfrj9X7w5eHcMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/index.vue?macro=true";
import { default as reportHCJYtlc8bfR_r8KH3YpmkTWoHiiP_qDAl_8jvQU25AgMeta } from "/codebuild/output/src2732330269/src/repo/pages/browse/report.vue?macro=true";
import { default as profilezOJ8nRT8GyObLm4XYpI8xBCdwJjCjpnnLKlsCtO4Dl0Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/profile.vue?macro=true";
import { default as loginr6g_IwMIMzomX8yqKd_45kKq9r2QdNS0mxzOFs_45tt6XDQMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/login.vue?macro=true";
import { default as privacy_45policyfUH3i8wkAP4M5zhR5n9An0kNk5R2attpH3oXyY9Omz0Meta } from "/codebuild/output/src2732330269/src/repo/pages/privacy-policy.vue?macro=true";
import { default as refunds_45policy_LuEC11zugVXAl8p_nRNMS7M0uf9GDRifeO6IyF7LkMMeta } from "/codebuild/output/src2732330269/src/repo/pages/refunds-policy.vue?macro=true";
import { default as reset_45password_8zrg1fvnlIhw08o_rg4sEmSedIJe8SwnJBsrA0nM2sMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/reset-password.vue?macro=true";
import { default as payoutAZUPg5wWF2LFYNquIOZiMo3U05O0AFt5ZUHCu6FI9KoMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/payout.vue?macro=true";
import { default as indexAG68ghOgtxdL_45skqa8p_45eXO1dD3eWKXadAMkBSNFCrYMeta } from "/codebuild/output/src2732330269/src/repo/pages/carts/[id]/index.vue?macro=true";
import { default as sign_45up9kIgokFwz2y5gCsKLxX_457KWMz15J1NPfhX6IjoKX4TMMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/sign-up.vue?macro=true";
import { default as onboardingkF1_45ZFjFaBu5OocQX2xKgmNxvSaz3xyTvFE6DftcxekMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/onboarding.vue?macro=true";
import { default as locationZgBRX_s7V_x9Nue6ksaTO1hmB3UmN4NFmyYQeGi1WAwMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/location.vue?macro=true";
import { default as registerCuYnM33sKNl9Y_45zJj2c3WahPP99aReKMpPVyaxF9lRUMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/register.vue?macro=true";
import { default as _91id_93NAO1YKwjksuyQL_4586Aso21lJiBq2HUZD8r_454fWdTA2EMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/orders/[id].vue?macro=true";
import { default as dashboardJuA9nj3gqp_SKN4Zj9Sv9sRqnolQxxICCCxHrYYqWVQMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/dashboard.vue?macro=true";
import { default as checkouthNeZwjxOgbzMHP3HS_45yESmTHu_45EiwGBTny9TQ9qxdNUMeta } from "/codebuild/output/src2732330269/src/repo/pages/carts/[id]/checkout.vue?macro=true";
import { default as indexOCISISZsin0pxjdvUNYBf1Ek1DqO9PapnD8ZhepDj18Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/orders/index.vue?macro=true";
import { default as edit_45address4a_4537Q2i_s_bexaR4MRHHFVbyH7qrZcVaDz9bNTo4GgMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/edit-address.vue?macro=true";
import { default as edit_45profileDF0SDMksaWNg97Qqm1LZukW4zobHod6gZRy6mVOxf9IMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/edit-profile.vue?macro=true";
import { default as _91id_93XAxueCha6AcQtjtiLLcXDHGvN4pFVbJvBNDOSjd_45BJcMeta } from "/codebuild/output/src2732330269/src/repo/pages/browse/products/[id].vue?macro=true";
import { default as trackingwLrhMha1dQnnbCs3keM0bpYZLnU6hLJyjvc2s_450RAzUMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/[id]/tracking.vue?macro=true";
import { default as _91id_93_lpiLs_45AZYYxOaF2ZXP02VBXJ3k2jaXw50yR1ELnnnoMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/[id].vue?macro=true";
import { default as terms_45and_45conditionsHE0sD5Eoz0_gqsI_Taul6YV0irDJYSSSVi7OmOTxMmAMeta } from "/codebuild/output/src2732330269/src/repo/pages/terms-and-conditions.vue?macro=true";
import { default as index9QEI548wMyjRLbUbvOi5Gtjrb3uC20QAnaGdJNipDokMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/index.vue?macro=true";
import { default as edit_45profileTl_kFupZJJFHikioA9NiB3pjZsc0Ow_UhxpSWp6OcFEMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/edit-profile.vue?macro=true";
import { default as integrationsNdhqvt2CEhZu_MHb3gNfiQLVPmoWOy_9VUQqQ_45yWO2kMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/integrations.vue?macro=true";
import { default as indexUKa3F2TY0wsD_BRicPIZoCzb_45mKHBoKkE_K_GCO_qegMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/index.vue?macro=true";
import { default as _91id_93mLVVa5i8OVP9m_45dovxikCOsJF9tPDB3pHECBkTycU3oMeta } from "/codebuild/output/src2732330269/src/repo/pages/browse/categories/[id].vue?macro=true";
import { default as index1LdzVT7zKa7IPxkS8fs4bDVmDpD3GL7a7CYi905DWwwMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/index.vue?macro=true";
import { default as create7OaFX8dmm_45q2MjwQjBNkYotsgs97lwKSSoGpEIuEWSQMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/create.vue?macro=true";
import { default as stripe_45accountpbyVx8FM3D3s_LK0_gK3U95nqElBBW9kE_45rCVy9lAV0Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/stripe-account.vue?macro=true";
import { default as indexmD33jqWxUOZ_45jPL3gNw0DLP9V_451K8t1GEUhNDkF0QhgMeta } from "/codebuild/output/src2732330269/src/repo/pages/browse/stores/[id]/index.vue?macro=true";
import { default as indextE23nYIgyCvBRelvpLhgWrvyPvCOXXlA3VUi__huF9AMeta } from "/codebuild/output/src2732330269/src/repo/pages/tools/integrations/index.vue?macro=true";
import { default as indexDWU7CeTFG0bUvZX7vDCp4nCVNKdRgeAROuG2i0ePrfIMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/help-center/index.vue?macro=true";
import { default as personal_45detailsE4tpCbI3WWf0__jqPkKRfg4lLHBEHnIrga1h_45lWvYPEMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/personal-details.vue?macro=true";
import { default as business_45detailshMsVAimGFn13vqCg_45iS4N5814D5MYDOnAEBb9z_5b68Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/business-details.vue?macro=true";
import { default as callback4Bl_PLM_45tlXUX39RR7e0_45Z9lAhx1BHCLAsW6lDCfb_45wMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/auth/social/apple/callback.vue?macro=true";
import { default as indexnLhu9A2FxOmdTXmn8lvH6qLMvbxHkcR7Y8MucmIhHpQMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/index.vue?macro=true";
import { default as editspkm_455wwq7XsK73_45NA0OUADQyzbTevuz8e4JK66NF2YMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/edit.vue?macro=true";
import { default as newhy3_458eYYJ7kirFN0DklemSZnKSkBbti690el1KZCe0UMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/forgot-password/new.vue?macro=true";
import { default as callbackP91PCav2X0sfe6NCujoMOewAI277Af7zMsUjx33UMxkMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/auth/social/google/callback.vue?macro=true";
import { default as indexn1cAuj18rTUcFG_xneqWSXI4hK8Hb6yFl9_n2UoLWT0Meta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/index.vue?macro=true";
import { default as tracking0JFpqMrE5decVKpFotX97x8DmLv0dXD4So79ee_1PeUMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/tracking.vue?macro=true";
import { default as indexySwASibIlbmwgqbh8qf9M_pDNL_Lgud9tzZs_45kAMO_QMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/index.vue?macro=true";
import { default as verify92rXB3uuZx3jJBmzoC5PyS0KIIFZr2SkLGAhA_sMvIsMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/forgot-password/verify.vue?macro=true";
import { default as report_45a_45problemjxZFQiNOKBizaAcVO7qTUj545aoDWhMYRLd1Sehud4cMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/help-center/report-a-problem.vue?macro=true";
import { default as indexvBTMsI3WyDjNCcoNE0Tst92YKknQDuqSjH8rp0pghroMeta } from "/codebuild/output/src2732330269/src/repo/pages/tools/integrations/woocommerce/index.vue?macro=true";
import { default as _91cartId_93VjkBp40h1OXcz9u6UIlWWyYb7O4T0CzsP_45hoy0oA4EkMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/re-order/[cartId].vue?macro=true";
import { default as delete_45accountsmYgsxnZokTrT_45eopte1nOETdItznnIIH_m3pFYREfAMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/delete-account.vue?macro=true";
import { default as update_45passwordZTvleVY2_k1WfVV8AgaUm9L5nv3v39sU00zRdbPtwuoMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/update-password.vue?macro=true";
import { default as _91categoryId_93Ngaeb4sSN7k2UGMwaB2p85qdmvXrxqWUnEPSoV6IPF8Meta } from "/codebuild/output/src2732330269/src/repo/pages/browse/stores/[id]/categories/[categoryId].vue?macro=true";
import { default as ListingDetailSkeletonYeun86Kq7f2gMfC9ivt8ArE4JtBB0Jk8V5_P6sZH3IUMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/ListingDetailSkeleton.vue?macro=true";
import { default as update_45email_45addressJdHGxX9_45L4VV7HB_457tMJRL1lzfAGHFOit8krltrzENAMeta } from "/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/update-email-address.vue?macro=true";
import { default as component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta } from "/codebuild/output/src2732330269/src/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0 } from "/codebuild/output/src2732330269/src/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexdJaF683ROKfKyXXMiyqDaR1KwZGA8sf02gv4JsirbG8Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginC39ONcVRpLatST00n23ETySFJ6usaUOuxGmO4gGZmj8Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verifyCC7JR1iPNmdNChcOn8_45R0Gu215iBAKbtVJk9MA4SfyQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/verify.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: supportFjdsqARRTg64JTQqzDZOE2f2aHH5id0xxZBDT7xOteQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/support.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerceMIts4N6rWFNFHnzy3ZOmPmKEJfJJ4oT9N31BoU7fkMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/register.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingheK_45ra6n21nAAiqHHVo1SNVcu_HdzN1c_3OAnTUp09EMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/onboarding.vue")
  },
  {
    name: "carts",
    path: "/carts",
    meta: indexSA48ABsVnvnWWcJq3UEAGf3aZSe7VuOHozRMmw_52XYMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/carts/index.vue")
  },
  {
    name: "marketplace",
    path: "/marketplace",
    meta: marketplaceE1aGFU9ed8D3E3gKX3J5Cnij17HjJfTCDDPHd9S1RiAMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/marketplace.vue")
  },
  {
    name: _91id_93LFYE_bBPTeWH49uzkDJTxm0oZQOu6ntZEHV8_jgSmO8Meta?.name,
    path: "/orders/:id()",
    meta: _91id_93LFYE_bBPTeWH49uzkDJTxm0oZQOu6ntZEHV8_jgSmO8Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/orders/[id].vue"),
    children: [
  {
    name: "orders-id",
    path: "",
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/orders/[id]/index.vue")
  },
  {
    name: "orders-id-mark-as-delivered",
    path: "mark-as-delivered",
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/orders/[id]/mark-as-delivered.vue")
  }
]
  },
  {
    name: "tools",
    path: "/tools",
    meta: index8cUZfaAEA3n_45OP1DiKw6U8f0SPvI_b6dBtavE48WfpsMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/tools/index.vue")
  },
  {
    name: "browse",
    path: "/browse",
    meta: indexsGvGKn4vWBlvLM7ar6Lvqygol9yTiFhl_BAWnCX1TfMMeta || {},
    redirect: "/",
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/index.vue")
  },
  {
    name: "driver",
    path: "/driver",
    meta: indexcc8QD2hncOQXVM0OLwiQx5D7JHidhBjd1_45Pw6BmbSxcMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/index.vue")
  },
  {
    name: "account-about",
    path: "/account/about",
    meta: aboutljk_vfsivC5K9uoQqaficHZuUdaaehj1XDy6cJPX5eAMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/account/about.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexQ9kssc_45OkdHBDuRVJwDjTni81KZ5oISNfrj9X7w5eHcMeta || {},
    redirect: "/account/account-settings",
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/index.vue")
  },
  {
    name: "browse-report",
    path: "/browse/report",
    meta: reportHCJYtlc8bfR_r8KH3YpmkTWoHiiP_qDAl_8jvQU25AgMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/report.vue")
  },
  {
    name: "driver-profile",
    path: "/driver/profile",
    meta: profilezOJ8nRT8GyObLm4XYpI8xBCdwJjCjpnnLKlsCtO4Dl0Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/profile.vue")
  },
  {
    name: "merchant-login",
    path: "/merchant/login",
    meta: loginr6g_IwMIMzomX8yqKd_45kKq9r2QdNS0mxzOFs_45tt6XDQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/login.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyfUH3i8wkAP4M5zhR5n9An0kNk5R2attpH3oXyY9Omz0Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/privacy-policy.vue")
  },
  {
    name: "refunds-policy",
    path: "/refunds-policy",
    meta: refunds_45policy_LuEC11zugVXAl8p_nRNMS7M0uf9GDRifeO6IyF7LkMMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/refunds-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password_8zrg1fvnlIhw08o_rg4sEmSedIJe8SwnJBsrA0nM2sMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/reset-password.vue")
  },
  {
    name: "merchant-payout",
    path: "/merchant/payout",
    meta: payoutAZUPg5wWF2LFYNquIOZiMo3U05O0AFt5ZUHCu6FI9KoMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/payout.vue")
  },
  {
    name: "carts-id",
    path: "/carts/:id()",
    meta: indexAG68ghOgtxdL_45skqa8p_45eXO1dD3eWKXadAMkBSNFCrYMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/carts/[id]/index.vue")
  },
  {
    name: "merchant-sign-up",
    path: "/merchant/sign-up",
    meta: sign_45up9kIgokFwz2y5gCsKLxX_457KWMz15J1NPfhX6IjoKX4TMMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/sign-up.vue")
  },
  {
    name: "driver-onboarding",
    path: "/driver/onboarding",
    meta: onboardingkF1_45ZFjFaBu5OocQX2xKgmNxvSaz3xyTvFE6DftcxekMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/onboarding.vue")
  },
  {
    name: "merchant-location",
    path: "/merchant/location",
    meta: locationZgBRX_s7V_x9Nue6ksaTO1hmB3UmN4NFmyYQeGi1WAwMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/location.vue")
  },
  {
    name: "merchant-register",
    path: "/merchant/register",
    meta: registerCuYnM33sKNl9Y_45zJj2c3WahPP99aReKMpPVyaxF9lRUMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/register.vue")
  },
  {
    name: "driver-orders-id",
    path: "/driver/orders/:id()",
    meta: _91id_93NAO1YKwjksuyQL_4586Aso21lJiBq2HUZD8r_454fWdTA2EMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/orders/[id].vue")
  },
  {
    name: "merchant-dashboard",
    path: "/merchant/dashboard",
    meta: dashboardJuA9nj3gqp_SKN4Zj9Sv9sRqnolQxxICCCxHrYYqWVQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/dashboard.vue")
  },
  {
    name: "carts-id-checkout",
    path: "/carts/:id()/checkout",
    meta: checkouthNeZwjxOgbzMHP3HS_45yESmTHu_45EiwGBTny9TQ9qxdNUMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/carts/[id]/checkout.vue")
  },
  {
    name: "driver-orders",
    path: "/driver/orders",
    meta: indexOCISISZsin0pxjdvUNYBf1Ek1DqO9PapnD8ZhepDj18Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/driver/orders/index.vue")
  },
  {
    name: "account-edit-address",
    path: "/account/edit-address",
    meta: edit_45address4a_4537Q2i_s_bexaR4MRHHFVbyH7qrZcVaDz9bNTo4GgMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/edit-address.vue")
  },
  {
    name: "account-edit-profile",
    path: "/account/edit-profile",
    meta: edit_45profileDF0SDMksaWNg97Qqm1LZukW4zobHod6gZRy6mVOxf9IMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/edit-profile.vue")
  },
  {
    name: "browse-products-id",
    path: "/browse/products/:id()",
    meta: _91id_93XAxueCha6AcQtjtiLLcXDHGvN4pFVbJvBNDOSjd_45BJcMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/products/[id].vue")
  },
  {
    name: "merchant-orders-id",
    path: "/merchant/orders/:id()",
    meta: _91id_93_lpiLs_45AZYYxOaF2ZXP02VBXJ3k2jaXw50yR1ELnnnoMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/[id].vue"),
    children: [
  {
    name: "merchant-orders-id-tracking",
    path: "tracking",
    meta: trackingwLrhMha1dQnnbCs3keM0bpYZLnU6hLJyjvc2s_450RAzUMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/[id]/tracking.vue")
  }
]
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionsHE0sD5Eoz0_gqsI_Taul6YV0irDJYSSSVi7OmOTxMmAMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/terms-and-conditions.vue")
  },
  {
    name: "customer-orders",
    path: "/customer/orders",
    meta: index9QEI548wMyjRLbUbvOi5Gtjrb3uC20QAnaGdJNipDokMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/index.vue")
  },
  {
    name: "merchant-edit-profile",
    path: "/merchant/edit-profile",
    meta: edit_45profileTl_kFupZJJFHikioA9NiB3pjZsc0Ow_UhxpSWp6OcFEMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/edit-profile.vue")
  },
  {
    name: "merchant-integrations",
    path: "/merchant/integrations",
    meta: integrationsNdhqvt2CEhZu_MHb3gNfiQLVPmoWOy_9VUQqQ_45yWO2kMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/integrations.vue")
  },
  {
    name: "merchant-orders",
    path: "/merchant/orders",
    meta: indexUKa3F2TY0wsD_BRicPIZoCzb_45mKHBoKkE_K_GCO_qegMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/orders/index.vue")
  },
  {
    name: "browse-categories-id",
    path: "/browse/categories/:id()",
    meta: _91id_93mLVVa5i8OVP9m_45dovxikCOsJF9tPDB3pHECBkTycU3oMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/categories/[id].vue")
  },
  {
    name: "merchant-listing",
    path: "/merchant/listing",
    meta: index1LdzVT7zKa7IPxkS8fs4bDVmDpD3GL7a7CYi905DWwwMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/index.vue")
  },
  {
    name: "merchant-listing-create",
    path: "/merchant/listing/create",
    meta: create7OaFX8dmm_45q2MjwQjBNkYotsgs97lwKSSoGpEIuEWSQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/create.vue")
  },
  {
    name: "merchant-stripe-account",
    path: "/merchant/stripe-account",
    meta: stripe_45accountpbyVx8FM3D3s_LK0_gK3U95nqElBBW9kE_45rCVy9lAV0Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/stripe-account.vue")
  },
  {
    name: "browse-stores-id",
    path: "/browse/stores/:id()",
    meta: indexmD33jqWxUOZ_45jPL3gNw0DLP9V_451K8t1GEUhNDkF0QhgMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/stores/[id]/index.vue")
  },
  {
    name: "tools-integrations",
    path: "/tools/integrations",
    meta: indextE23nYIgyCvBRelvpLhgWrvyPvCOXXlA3VUi__huF9AMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/tools/integrations/index.vue")
  },
  {
    name: "account-help-center",
    path: "/account/help-center",
    meta: indexDWU7CeTFG0bUvZX7vDCp4nCVNKdRgeAROuG2i0ePrfIMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/help-center/index.vue")
  },
  {
    name: "customer-personal-details",
    path: "/customer/personal-details",
    meta: personal_45detailsE4tpCbI3WWf0__jqPkKRfg4lLHBEHnIrga1h_45lWvYPEMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/personal-details.vue")
  },
  {
    name: "merchant-business-details",
    path: "/merchant/business-details",
    meta: business_45detailshMsVAimGFn13vqCg_45iS4N5814D5MYDOnAEBb9z_5b68Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/business-details.vue")
  },
  {
    name: "auth-social-apple-callback",
    path: "/auth/social/apple/callback",
    meta: callback4Bl_PLM_45tlXUX39RR7e0_45Z9lAhx1BHCLAsW6lDCfb_45wMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/auth/social/apple/callback.vue")
  },
  {
    name: "customer-orders-id",
    path: "/customer/orders/:id()",
    meta: indexnLhu9A2FxOmdTXmn8lvH6qLMvbxHkcR7Y8MucmIhHpQMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/index.vue")
  },
  {
    name: "merchant-listing-id-edit",
    path: "/merchant/listing/:id()/edit",
    meta: editspkm_455wwq7XsK73_45NA0OUADQyzbTevuz8e4JK66NF2YMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/edit.vue")
  },
  {
    name: "account-forgot-password-new",
    path: "/account/forgot-password/new",
    meta: newhy3_458eYYJ7kirFN0DklemSZnKSkBbti690el1KZCe0UMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/forgot-password/new.vue")
  },
  {
    name: "auth-social-google-callback",
    path: "/auth/social/google/callback",
    meta: callbackP91PCav2X0sfe6NCujoMOewAI277Af7zMsUjx33UMxkMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/auth/social/google/callback.vue")
  },
  {
    name: "merchant-listing-id",
    path: "/merchant/listing/:id()",
    meta: indexn1cAuj18rTUcFG_xneqWSXI4hK8Hb6yFl9_n2UoLWT0Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/index.vue")
  },
  {
    name: "customer-orders-id-tracking",
    path: "/customer/orders/:id()/tracking",
    meta: tracking0JFpqMrE5decVKpFotX97x8DmLv0dXD4So79ee_1PeUMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/tracking.vue")
  },
  {
    name: "account-account-settings",
    path: "/account/account-settings",
    meta: indexySwASibIlbmwgqbh8qf9M_pDNL_Lgud9tzZs_45kAMO_QMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/index.vue")
  },
  {
    name: "account-forgot-password-verify",
    path: "/account/forgot-password/verify",
    meta: verify92rXB3uuZx3jJBmzoC5PyS0KIIFZr2SkLGAhA_sMvIsMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/forgot-password/verify.vue")
  },
  {
    name: "account-help-center-report-a-problem",
    path: "/account/help-center/report-a-problem",
    meta: report_45a_45problemjxZFQiNOKBizaAcVO7qTUj545aoDWhMYRLd1Sehud4cMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/help-center/report-a-problem.vue")
  },
  {
    name: "tools-integrations-woocommerce",
    path: "/tools/integrations/woocommerce",
    meta: indexvBTMsI3WyDjNCcoNE0Tst92YKknQDuqSjH8rp0pghroMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/tools/integrations/woocommerce/index.vue")
  },
  {
    name: "customer-orders-id-re-order-cartId",
    path: "/customer/orders/:id()/re-order/:cartId()",
    meta: _91cartId_93VjkBp40h1OXcz9u6UIlWWyYb7O4T0CzsP_45hoy0oA4EkMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/customer/orders/[id]/re-order/[cartId].vue")
  },
  {
    name: "account-account-settings-delete-account",
    path: "/account/account-settings/delete-account",
    meta: delete_45accountsmYgsxnZokTrT_45eopte1nOETdItznnIIH_m3pFYREfAMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/delete-account.vue")
  },
  {
    name: "account-account-settings-update-password",
    path: "/account/account-settings/update-password",
    meta: update_45passwordZTvleVY2_k1WfVV8AgaUm9L5nv3v39sU00zRdbPtwuoMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/update-password.vue")
  },
  {
    name: "browse-stores-id-categories-categoryId",
    path: "/browse/stores/:id()/categories/:categoryId()",
    meta: _91categoryId_93Ngaeb4sSN7k2UGMwaB2p85qdmvXrxqWUnEPSoV6IPF8Meta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/pages/browse/stores/[id]/categories/[categoryId].vue")
  },
  {
    name: "merchant-listing-id-ListingDetailSkeleton",
    path: "/merchant/listing/:id()/ListingDetailSkeleton",
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/merchant/listing/[id]/ListingDetailSkeleton.vue")
  },
  {
    name: "account-account-settings-update-email-address",
    path: "/account/account-settings/update-email-address",
    meta: update_45email_45addressJdHGxX9_45L4VV7HB_457tMJRL1lzfAGHFOit8krltrzENAMeta || {},
    component: () => import("/codebuild/output/src2732330269/src/repo/modules/auth/pages/account/account-settings/update-email-address.vue")
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/about-us",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/pricing",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/contact",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/coverage",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/feedback",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/index-old",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/customer-terms-and-conditions",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  },
  {
    name: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0Meta?.name,
    path: "/merchant-terms-and-conditions",
    component: component_45stubooaxZ1N_45Z_09j4E_45iFp5kADRdi9mjfaKnjXFfH4EQc0
  }
]